import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SvgMatType } from 'src/app/constants/icons';
import { AgentPaths, BaseModulePaths } from 'src/app/constants/routes';

import { SessionService } from 'src/app/services/storage/session.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NavgiationLink, NavigationTopNav } from 'src/app/models/navigation';

import { Session } from 'src/app/models/session';
import { AuthService } from 'src/app/services/auth.service';

import { DialogLogoutComponent } from 'src/app/components/shared/dialog/logout.component';
import { SessionStatus } from 'src/app/constants/session';
import { StyleService } from 'src/app/services/styles.service';
import { DialogPasswordComponent } from '../dialog/password.component';
import { DialogSupportComponent } from '../dialog/support.component';
import { DialogTranslationComponent } from '../dialog/translation.component';
import { DialogRegisteredEmailComponent } from '../dialog/registered-email.component';
import { TermsOfServiceComponent } from '../documents/terms-of-service.component';
import { DialogUpdateMFAComponent } from '../dialog/update-mfa.component';

@Component({
  selector: 'mwp-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  public linkHome: string = '';
  public operatingMode: string = '';
  public svgType = SvgMatType;
  public links: NavgiationLink[];
  public isAgent: boolean;
  public isMember: boolean;
  public isAdmin: boolean;
  public isDarkMode: boolean;
  public isChangePasswordVisbile: boolean;
  public isUpdateRegisteredEmailVisbile: boolean;
  public copyright: string;
  public appVersion: string;

  public agentName: string;
  public adminName: string;
  public memberName: string;
  public companyName: string;
  public memberSID: string;

  public isVersionError: boolean;
  public BaseModulePaths = BaseModulePaths;

  constructor(
    private authService: AuthService,
    private router: Router,
    private sessionService: SessionService,
    private navigationService: NavigationService,
    private dialog: MatDialog,
    private styleService: StyleService
  ) {
    this.navigationService.$TopNavMenu.subscribe(
      (navigationTopNav: NavigationTopNav) => {
        this.links = navigationTopNav.links;
      }
    );
  }

  ngOnInit() {
    const today = new Date();
    this.copyright = `Copyright © ${today.getFullYear()}`;

    this.sessionService.$Session.subscribe((session: Session) => {
      if (session.operatingMode) {
        this.appVersion = `MyWorkplace, Inc. ${session.operatingMode.version}`;
        this.operatingMode = session.operatingMode.operatingMode;
        this.linkHome = session.operatingMode.linkHome;

        this.isAgent = session.isAgent;
        this.isAdmin = session.isAdmin;
        this.isMember = session.isMember;
        this.isDarkMode = session.isDarkMode;

        if (this.isAgent) {
          this.agentName = session.agent.name;
          this.isChangePasswordVisbile = !session.member;
        } else {
          this.agentName = null;
        }

        if (this.isAdmin) this.adminName = session.adminUserName;
        else this.adminName = null;

        if (this.isMember) {
          this.memberName = session.member.memberName;
          this.companyName = session.member.companyName;
          this.memberSID = session.member.systemNumber.toString();
          this.isChangePasswordVisbile = this.isUpdateRegisteredEmailVisbile =
            !session.agent && !session.isAdmin;
        } else {
          this.memberName = this.memberSID = null;
        }
      }

      this.isVersionError = session.isVersionIncompatible;
    });

    this.sessionService.$SessionClear.subscribe((status: string) => {
      if (status == SessionStatus.clearMember) {
        this.isMember = false;
      }
    });
  }

  public isHeaderLinkActive(linkeURL: string): boolean {
    return this.router.url.startsWith(linkeURL);
  }

  public agentExitMemberSession(): void {
    this.authService.agentMemberLogout().subscribe(() => {
      this.router.navigateByUrl(AgentPaths.CounselorMemberLookup);
    });
  }

  public navigateToURL(linkeURL: string): void {
    this.router.navigateByUrl(linkeURL);
  }

  // public onDarkModeChange(event: MatSlideToggleChange): void {
  //     this.styleService.setDarkMode(event.checked);
  // }

  public openLanguageDialog(): void {
    this.dialog.open(DialogTranslationComponent, {
      panelClass: 'mwp-modal-override-300',
    });
  }

  public openUpdatePasswordDialog(): void {
    this.dialog.open(DialogPasswordComponent, {
      panelClass: 'mwp-modal-override-300',
    });
  }

  public openUpdateRegisteredEmailDialog(): void {
    this.dialog.open(DialogRegisteredEmailComponent, {
      panelClass: 'mwp-modal-override-300',
    });
  }

  public openSupportDialog(): void {
    this.dialog.open(DialogSupportComponent, {
      panelClass: 'mwp-modal-override-750',
    });
  }

  public openLogoutDialog(): void {
    this.dialog.open(DialogLogoutComponent);
  }

  public openMFADialog(): void {
    this.dialog.open(DialogUpdateMFAComponent, {
      panelClass: 'mwp-modal-override-300',
    });
  }
}
